import { Injectable } from '@angular/core';
import { IAddon } from '../../models/addon.model';
import { Provider } from '../provider';

@Injectable()
export class AddonService extends Provider<IAddon> {
  protected url = "events/addons";
}